import { NgModule } from "@angular/core";
import { CommonPackageModule } from "src/app/modules/common-package.module";
import { DataconsoleComponent } from "./dataconsole.component";

@NgModule({
    declarations: [DataconsoleComponent],
    imports: [CommonPackageModule],
    exports: [DataconsoleComponent],
})
export class DataConsoleModule{}